"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var FileTypePpt = function FileTypePpt(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    fill: "#d24726",
    fillRule: "evenodd",
    d: "M8 0C5.796875 0 4 1.796875 4 4v7H1c-.550781 0-1 .449219-1 1v6c0 .550781.449219 1 1 1h3v3c0 2.203125 1.796875 4 4 4h12c2.203125 0 4-1.796875 4-4V8c0-1.0625-.972656-2.070312-2.71875-3.78125-.242187-.238281-.503906-.503906-.75-.75-.246094-.246094-.511719-.476562-.75-.71875C18.070313 1.003906 17.0625 0 16 0H8zm0 2h7.28125c.722656.183594.71875 1.050781.71875 1.9375V7c0 .550781.449219 1 1 1h3c.996094 0 2 .003906 2 1v13c0 1.105469-.894531 2-2 2H8c-1.105469 0-2-.894531-2-2v-3h12c.550781 0 1-.449219 1-1v-6c0-.550781-.449219-1-1-1H6V4c0-1.105469.894531-2 2-2z"
  }), (0, _preact.h)("path", {
    fill: "#fff",
    d: "M3.54492 15.996v2.004H2.37305v-5.6875h2.21875c.42708 0 .80273.0781 1.12695.2344.32422.1562.57357.3782.74805.666.17448.2877.26172.6152.26172.9824 0 .5573-.19076.9967-.57227 1.3183-.38151.3216-.90951.4824-1.58398.4824H3.54492zm0-.9492h1.04688c.3099 0 .54623-.0729.70898-.2188.16276-.1458.24414-.3541.24414-.625 0-.2786-.08203-.5039-.24609-.6758-.16407-.1718-.39063-.2604-.67969-.2656H3.54492v1.7852zm5.16016.9492v2.004H7.5332v-5.6875h2.21875c.4271 0 .80275.0781 1.12695.2344.32422.1562.57359.3782.74809.666.17448.2877.26171.6152.26171.9824 0 .5573-.19075.9967-.57226 1.3183-.38151.3216-.90951.4824-1.58398.4824H8.70508zm0-.9492h1.04687c.30991 0 .54625-.0729.70899-.2188.16276-.1458.24414-.3541.24414-.625 0-.2786-.08203-.5039-.24609-.6758-.16406-.1718-.39063-.2604-.67969-.2656H8.70508v1.7852zm8.26952-2.7343h-1.74219V18h-1.17188v-4.7383h-1.71875v-.9492h4.63282v.9492z"
  }));
};

var _default = FileTypePpt;
exports.default = _default;